import { SearchCanvasesOutput, RenameCanvasInput } from "@zapier/bff";
import { trpc } from "../trpc";

type QueryCanvasCache = SearchCanvasesOutput | undefined;

const updateCanvasInSearchResults = (
  cache: QueryCanvasCache,
  { id, name }: RenameCanvasInput,
) => {
  if (!cache) {
    return cache;
  }

  if (!cache.results) {
    return cache;
  }

  return {
    ...cache,
    results: cache.results.map((canvas) =>
      canvas.id === id ? { ...canvas, name } : canvas,
    ),
  };
};

interface Input {
  folderId?: string; // used for cache invalidation
}

export const useRenameCanvas = (input: Input) => {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const mutation = trpc.canvas.rename.useMutation({
    onMutate: (variables) => {
      utils.canvas.search.cancel();

      utils.canvas.search.setQueriesData(
        {},
        { exact: false },
        (cache: QueryCanvasCache) =>
          updateCanvasInSearchResults(cache, variables),
      );

      utils.canvas.get.setData({ id: variables.id }, (cache) => {
        return cache
          ? {
              ...cache,
              name: variables.name,
            }
          : cache;
      });
    },
    onSettled: (_data, _error, variables) => {
      // Invalidate on settled so regardless of success or failure we refetch to show fresh data
      utils.canvas.search.invalidate();

      if (variables?.id) {
        utils.canvas.get.invalidate({ id: variables.id });
      }

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({ folderId });
      }
    },
  });

  return {
    rename: mutation.mutate,
    isLoading: mutation.isPending,
  };
};
